import { Dialog, DialogContent } from "@mui/material";
import {
  PlatformUser,
  PlatformUserCreateResponse,
} from "types/interfaces/adminUsers";
import UserManagementPanel, {
  type InitialPassword,
} from "./UserManagementPanel";
import type { UserManagementDrafts } from "userManagement/platformDraftsStorage";

interface UserEditModalProps {
  open: boolean;
  user: PlatformUser | null;
  onClose: () => void;
  onCloseRequest?: () => void;
  onUserUpdated: (user: PlatformUser | PlatformUserCreateResponse) => void;
  initialPassword?: InitialPassword | null;
  onUserArchived?: () => void;
  onSavingChange?: (saving: boolean) => void;
  onUnsavedChange?: (dirty: boolean) => void;
  drafts: Record<number, UserManagementDrafts>;
  onDraftsChange: (
    updater: (
      prev: Record<number, UserManagementDrafts>,
    ) => Record<number, UserManagementDrafts>,
  ) => void;
  userType?: "client_users" | "internal_users";
}

export default function UserEditModal({
  open,
  user,
  onClose,
  onCloseRequest,
  onUserUpdated,
  onUserArchived,
  onSavingChange,
  onUnsavedChange,
  drafts,
  onDraftsChange,
  userType = "internal_users",
  initialPassword = null,
}: UserEditModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onCloseRequest ?? onClose}
      // The Access step puts the group or the switches next to what they grant.
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: "hidden",
          height: { xs: "90vh", sm: 840 },
          maxHeight: { xs: "90vh", sm: 840 },
        },
      }}
    >
      <DialogContent sx={{ p: 0, display: "flex", overflow: "hidden" }}>
        <UserManagementPanel
          user={user}
          onClose={onClose}
          onCloseRequest={onCloseRequest}
          onUserUpdated={onUserUpdated}
          onUserArchived={onUserArchived}
          onSavingChange={onSavingChange}
          onUnsavedChange={onUnsavedChange}
          drafts={drafts}
          onDraftsChange={onDraftsChange}
          fillViewport
          userType={userType}
          initialPassword={initialPassword}
        />
      </DialogContent>
    </Dialog>
  );
}
